export default __webpack_public_path__ + "static/media/Logo.d756e09c.svg";